import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function ListingNew() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    listing_type: "hermitage",
    title: "",
    summary: "",
    description: "",
    region: "USA",
    location: "",
    duration: "",
    terms: "",
    image_url: "",
  });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const { data } = await api.post("/listings", form);
      navigate(`/listings/${data.listing_id}`);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="max-w-3xl mx-auto px-6 sm:px-10 py-12">
      <p className="label-overline">Post a new listing</p>
      <h1 className="font-display text-5xl mt-2 mb-2">A notice for the bulletin</h1>
      <div className="fleuron mb-8">❦</div>

      <form onSubmit={onSubmit} className="parchment-card space-y-6" data-testid="listing-form">
        <div>
          <label className="label-overline block mb-2">What is this?</label>
          <div className="grid grid-cols-2 gap-2">
            <button type="button" data-testid="listing-type-hermitage" onClick={() => setForm({ ...form, listing_type: "hermitage" })} className={`py-3 border text-sm font-body ${form.listing_type === "hermitage" ? "bg-ink-black text-parchment-faded border-ink-black" : "border-rule hover:bg-parchment-bone"}`}>I am a Host offering a hermitage</button>
            <button type="button" data-testid="listing-type-hermit" onClick={() => setForm({ ...form, listing_type: "hermit_offer" })} className={`py-3 border text-sm font-body ${form.listing_type === "hermit_offer" ? "bg-ink-black text-parchment-faded border-ink-black" : "border-rule hover:bg-parchment-bone"}`}>I am a Hermit offering myself</button>
          </div>
        </div>

        <div>
          <label className="label-overline block mb-2">Title</label>
          <input data-testid="listing-title" className="field" required value={form.title} onChange={set("title")} placeholder="A Mossy Cottage in the Cotswolds" />
        </div>
        <div>
          <label className="label-overline block mb-2">One-line summary</label>
          <input data-testid="listing-summary" className="field" required value={form.summary} onChange={set("summary")} placeholder="A stone cottage beside a brook, seeking a quiet soul." />
        </div>
        <div>
          <label className="label-overline block mb-2">Full description</label>
          <textarea data-testid="listing-description" className="field" rows={8} required value={form.description} onChange={set("description")} placeholder="Describe the land, the hermitage, the orchard…" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="label-overline block mb-2">Region</label>
            <select data-testid="listing-region" className="field" value={form.region} onChange={set("region")}>
              <option>USA</option><option>UK</option><option>Other</option>
            </select>
          </div>
          <div>
            <label className="label-overline block mb-2">Location</label>
            <input data-testid="listing-location" className="field" required value={form.location} onChange={set("location")} placeholder="Yorkshire, England" />
          </div>
        </div>

        <div>
          <label className="label-overline block mb-2">Duration</label>
          <input data-testid="listing-duration" className="field" required value={form.duration} onChange={set("duration")} placeholder="One year · One season · Open" />
        </div>

        <div>
          <label className="label-overline block mb-2">Terms of arrangement</label>
          <textarea data-testid="listing-terms" className="field" rows={4} value={form.terms} onChange={set("terms")} placeholder="What is expected? What is offered? What is forbidden?" />
        </div>

        <div>
          <label className="label-overline block mb-2">Image URL (optional)</label>
          <input data-testid="listing-image" className="field" value={form.image_url} onChange={set("image_url")} placeholder="https://…" />
        </div>

        {error && <p className="text-wax-red text-sm italic">{error}</p>}
        <button data-testid="listing-submit" disabled={submitting} className="wax-button w-full">{submitting ? "Posting…" : "Post the notice"}</button>
      </form>
    </main>
  );
}
